import { useState } from 'react';
import { api, extractErrorMessage } from '../api/client';
import { useToast } from '../components/Toast';

interface PdfImportResult {
  texto_completo: string;
  detectado: Record<string, any>;
}

export function usePdfImport(endpoint: string) {
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState<PdfImportResult | null>(null);
  const toast = useToast();

  const importPdf = async (file: File): Promise<PdfImportResult> => {
    setUploading(true);
    try {
      const data = await api.upload<PdfImportResult>(endpoint, file);
      setResult(data);
      return data;
    } catch (e) {
      toast.addToast(extractErrorMessage(e), 'error');
      throw e;
    } finally {
      setUploading(false);
    }
  };

  return { uploading, importPdf, result };
}
